<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
            @shown="focusSearch"
        >
            <template #modal-title>
                Add SBP Image
            </template>

            <sbp-search
                ref="sbp-search"
                @link="linkAsset"
                @unlink="unlinkAsset"
            />

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
// import RelatedMediaSearch from '@/components/modals/article/related_media/Search'
import SbpSearch from '@/components/modals/media/Search'

export default {
    data: () => ({

    }),
    props: [
        'value',
    ],
    components: {
        // RelatedMediaSearch
        SbpSearch
    },
    computed: {
        modal_id () {
            let modal_id = 'image-modal'
            return modal_id
        }
    },
    methods: {
        linkAsset (asset, width, position, size) {
            this.$emit('link', asset, width, position, size)
        },
        unlinkAsset (asset) {
            this.$swal({
                html: 'Are you sure you want to unlink this asset?',
                showCancelButton: true,
                confirmButtonText: 'Unlink Asset',
                confirmButtonColor: '#E67E22',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.$emit('unlink', asset)
                }
            })
        },
        focusSearch () {
            if (
                this.$refs['merlin-search'] &&
                this.$refs['merlin-search'].$refs['search-term']
            ) {
                this.$refs['merlin-search'].$refs['search-term'].focus()
            }
        },
        cancel (event) {
            event.preventDefault()

            this.hide()
        },
        hide () {
            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')
        }
    }
}
</script>
